import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replace'
})
export class ReplacePipe implements PipeTransform {

  transform(value: string, subString: string, replaceValue: any): string {
    return value.replace(subString, replaceValue);
  }

}
